<template>
  <div class="expertCon">
    <div v-if="eventInfo.currentLink === 4 && curRole === '市中心管理人员'">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="会商专家" prop="expert">
          <!--          <Input v-model="formValidate.expert" type="text" placeholder="请输入会商专家"></Input>-->
          <CheckboxGroup v-model="formValidate.expert">
            <Checkbox v-for="(item,index) in exportsList" :key="index" :label="item.specialist.id">
              {{ item.specialist.name }}
            </Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="处置意见" prop="disposalOpinions">
          <Input v-model="formValidate.disposalOpinions" type="textarea" :autosize="{minRows: 5}"
                 placeholder="请输入处置意见"></Input>
        </FormItem>
        <FormItem label="是否发送短信" prop="isSendSms">
          <el-switch v-if="!isSend"
                     :disabled="!formValidate.expert.length"
                     v-model="formValidate.isSendSms"
                     active-color="#13ce66"
                     @change="isSendSmsChange"
                     inactive-color="#ff4949">
          </el-switch>
          <span v-else style="color: green">短信已成功发送</span>
        </FormItem>
      </Form>
      <div v-if="eventInfo.currentLink === 4" style="text-align: center">
        <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
        <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
      </div>
      <Modal v-model="smsModalIsShow" title="发送短信" @on-visible-change="sendModalChange">
        <Form :model="formValidate" :rules="smsSendRules" ref="smsRefs">
          <FormItem label="短信内容" prop="smsContent">
            <Input v-model="formValidate.smsContent" type="textarea" :autosize="{minRows: 5}"
                   placeholder="请输入短信内容"></Input>
          </FormItem>
        </Form>
        <div style="text-align: right" slot="footer">
          <Button @click="smsSendReset()" style="margin-left: 8px">取消</Button>
          <Button type="primary" @click="smsSend()" :loading="sendLoading">发送</Button>

        </div>
      </Modal>
    </div>
    <div v-else>
      <el-descriptions class="margin-top" size="medium" :column="1" border
                       :labelStyle="{'text-align': 'center','width':'20%','color':'#555'}">
        <el-descriptions-item label="会商专家">
          <CheckboxGroup v-model="formValidate.expert">
            <Checkbox disabled v-for="(item,index) in exportsList" :key="index" :label="item.specialist.id">
              {{ item.specialist.name }}
            </Checkbox>
          </CheckboxGroup>
        </el-descriptions-item>
        <el-descriptions-item label="处置意见">
          {{ formValidate.disposalOpinions }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  name: "expertConsultation",
  props: {
    eventInfo: {
      type: Object,
      default: () => {
      }
    },
    stepInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isSend: false,
      sendLoading: false,
      smsModalIsShow: false,
      exportsList: [],
      formValidate: {
        expert: [],
        disposalOpinions: '',
        isSendSms: false,
        smsContent: ''
      },
      smsSendRules: {
        smsContent: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
      },
      ruleValidate: {
        expert: [
          {required: true, message: '必填', trigger: 'blur', type: 'array'}
        ],
        disposalOpinions: [
          {required: true, message: '必填', trigger: 'blur'}
        ],
      },
      curRole: ''
    }
  },
  // watch: {
  //   userInfo: {
  //     immediate: true,
  //     deep: true,
  //     handler(newVal) {
  //       if (newVal) {
  //         console.log(newVal)
  //         this.curRole = newVal.roleNames
  //       }
  //     }
  //   }
  // },
  // computed: {
  //   userInfo: {
  //     get: function () {
  //       console.log(this.$store)
  //       return this.$store.state.user.userInfo
  //     },
  //     set: function () {
  //     }
  //   }
  // },
  mounted() {
    this.getUserData()
    // console.log(this.stepInfo)
    if (this.stepInfo !== '' && this.stepInfo !== null) {
      this.formatInfo()
    }
    this.getExportsList()
  },
  methods: {
    sendModalChange(val) {
      if (val) {
        this.formValidate.isSendSms = true
      } else {
        this.formValidate.isSendSms = false
      }
    },
    smsSend() {
      this.$refs['smsRefs'].validate((valid) => {
        if (valid) {
          this.sendLoading = true
          let request = {
            id: this.eventInfo.id,
            content: this.formValidate.smsContent,
            expert: this.formValidate.expert.join(',')
          }
          this.$http.post('/api/sendMessage', request).then(res => {
            console.log(res)
            if (res.status === 200) {
              this.$Message.success('发送成功')
              this.smsModalIsShow = false
              this.sendLoading = false
              this.formValidate.smsContent = ''
              this.formValidate.isSendSms = false
              this.isSend = true
            }
          })
        }
      })
    },
    smsSendReset() {
      this.smsModalIsShow = false
      this.formValidate.smsContent = ''
      this.formValidate.isSendSms = false
    },
    isSendSmsChange(val) {
      if (val) {
        this.smsModalIsShow = true
        this.formValidate.smsContent = `您好，请于  时间  到  地点  进行专家会商，谢谢！`
      } else {
        this.formValidate.smsContent = ''
      }
    },
    // 获取专家列表
    getExportsList() {
      this.$http.post('/api/specialist/getAll', {}).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.exportsList = res.data.data.list
        }
      })
    },
    getUserData() {
      this.$http.get('/api/system/cscpCurrentUserDetails').then(res => {
        console.log(res)
        if (res.status === 200) {
          this.curRole = res.data.roleNames
        }
      })
    },
    formatInfo() {
      console.log(this.stepInfo)
      let info = this.stepInfo.split(';')
      this.formValidate.expert = info[0].split('_')[1].split('|')
      this.formValidate.disposalOpinions = info[1].split('_')[1]
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // this.$Message.success('Success!');
          let params = {
            currentLink: this.eventInfo.currentLink,
            indexCode: this.eventInfo.deptIndexCode,
            information: `expert_${this.formValidate.expert.join('|')};disposalOpinions_${this.formValidate.disposalOpinions}`,
            messageId: this.eventInfo.id
          }
          // console.log(params)
          this.$http.post('/api/jumpNextLink', params).then(res => {
            // console.log(res)
            this.$emit('refreshStep')
          })
          this.$Message.success('提交成功!');
        } else {
          this.$Message.error('请填写!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.expertCon {
  width: 60%;
  margin: 0 auto;
}
</style>
